export const ZYANIMATOR_REFERENCE_READY = 'zyanimator-reference-ready';
export const ZYANIMATOR_REFERENCE_INIT = 'zyanimator-reference-init';

export type ZyAnimatorReferenceReadyMessage = {
    type: typeof ZYANIMATOR_REFERENCE_READY;
};

export type ZyAnimatorReferenceInitMessage = {
    type: typeof ZYANIMATOR_REFERENCE_INIT;
    animXMLToLoad: string;
    baseImageUrl: string;
};

export type ZyAnimatorReferenceMessage = ZyAnimatorReferenceReadyMessage | ZyAnimatorReferenceInitMessage;

export function buildReferencePopupUrl(baseUrl: string, parentOrigin: string): string {
    const url = new URL(baseUrl);
    url.searchParams.set('parentOrigin', parentOrigin);
    return url.toString();
}

export function isZyAnimatorReferenceReadyMessage(
    data: unknown,
    _expectedOrigin: string,
    source: MessageEventSource | null,
    expectedSource: Window | null,
): data is ZyAnimatorReferenceReadyMessage {
    return (
        source === expectedSource &&
        typeof data === 'object' &&
        data !== null &&
        (data as ZyAnimatorReferenceReadyMessage).type === ZYANIMATOR_REFERENCE_READY
    );
}

export function createReferenceInitMessage(animXMLToLoad: string, baseImageUrl: string): ZyAnimatorReferenceInitMessage {
    return {
        type: ZYANIMATOR_REFERENCE_INIT,
        animXMLToLoad,
        baseImageUrl,
    };
}

export function isZyAnimatorReferenceInitMessage(
    data: unknown,
    parentOrigin: string,
    eventOrigin: string,
    source: MessageEventSource | null,
): data is ZyAnimatorReferenceInitMessage {
    return (
        eventOrigin === parentOrigin &&
        source === window.opener &&
        typeof data === 'object' &&
        data !== null &&
        (data as ZyAnimatorReferenceInitMessage).type === ZYANIMATOR_REFERENCE_INIT &&
        typeof (data as ZyAnimatorReferenceInitMessage).animXMLToLoad === 'string' &&
        typeof (data as ZyAnimatorReferenceInitMessage).baseImageUrl === 'string'
    );
}

export function openReferencePopup(popupUrl: string, windowName = 'zyanimator-v1-reference'): Window | null {
    return window.open(popupUrl, windowName, 'popup,width=600,height=350,noopener=no');
}
